import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { arrayOf, bool, func, number, object, shape, string } from 'prop-types';
import queryString from 'query-string';
import { gql } from '@apollo/client';
import { graphql } from '@apollo/client/react/hoc';
import debounce from 'lodash.debounce';
import { jdxActions, jdxTitles } from '../../components/HRTMS/JDXUtils';

import LoadingIndicator from 'ps-components/LoadingIndicator/LoadingIndicator';
import { dynamicColumnTemplate } from 'ps-components/lib/formatters';
import {
  setDisplayIn,
  setSelectedBenchmarkYear,
  setViewName
} from '../../components/CompensationSummary/CompensationSummaryActions';
import { addJob, getJobsByID } from '../../components/JobMatching/OrgJobsActions';
import {
  setSelectedYearOverYearData,
  setYearOverYearDisplayIn
} from '../../components/YearOverYear/YearOverYearActions';
import { setSelectedMigrationData } from '../../components/SurveyMigration/actions/MigrationSettingsActions';
import { setSMAData } from '../../components/StructureModeling/StructureModelAnalytics/actions/GradeListActions';
import {
  initParticipationMatchReview,
  loadParticipationMatchReviewItems,
  resetParticipationMatchReview
} from 'ps-components/Modules/ParticipationCenter/actions/MatchReviewActions';
import { initializeAgreement } from '../../components/SurveyLibraryUpdate/Agreement/SLUAgreementActions';
import { hideSlideout, showSlideout } from 'ps-components/Slideout/SlideoutReducer';
import { loadJobDetails } from 'ps-components/Modules/AddJob/reducers/jobSurveyList';
import { launchEditJobSlideout } from 'ps-components/Modules/AddJob/reducers/addJob';
import { LINK_HASH_SUPPORT_CONTACT, slideoutAddresses } from 'ps-components/Slideout/SlideoutAddresses';
import { SLIDEOUTS as MarketPaySlideouts } from '../../components/Slideout/Slideouts';
import { SLIDEOUTS as CommonSlideouts } from 'ps-components/Slideout/Slideouts';
import JDXSettingsModal from '../../components/Modal/JDXSettingsModal';
import DefaultWeightModal from '../../components/Modal/DefaultWeightModal';

import {
  getMarketplaceMatches,
  resetMarketplaceMatches
} from '../../components/MarketPricing/MarketplaceMatches/MarketplaceMatchesActions';
import {
  applyWeighting,
  getApplyWeightingCounts,
  resetApplyWeighting
} from '../../components/MarketPricing/MarketPricingActions';
import { getJobPricingDetails } from '../../components/MarketPricing/JobPricing/JobPricingActions';
import { jobPricingGridActions } from '../../components/MarketPricing/JobPricingDetails/JobPricingGrid/JobPricingGridCreate';

import './Iframe.scss';
import { getDisplayInFromPayDivisor } from '../../lib/displayIn';
import {
  REVIEW_STATUS_IN_REVIEW,
  REVIEW_STATUS_LOAD_ERROR,
  REVIEW_STATUS_NO_REVIEW
} from 'ps-components/Modules/ParticipationCenter/reducers/MatchReviewReducer';
import MatchReviewErrorModal from 'ps-components/Modules/ParticipationCenter/containers/MatchReview/MatchReviewErrorModal/MatchReviewErrorModal';

const updateThumbnailCache = gql`
  mutation updateThumbnailCache($id: ID!, $workbook: WorkbookInput!) {
    updateVizCache(id: $id, workbook: $workbook)
  }
`;

const updateCache = graphql(updateThumbnailCache)

export class Iframe extends Component {
  static propTypes = {
    dispatch: func,
    onAction: func,
    featureFlags: arrayOf(
      shape({
        name: string,
        enabled: bool
      })
    ),
    match: object,
    location: object,
    config: object,
    history: object,
    session: object,
    jobDetails: object,
    launchDarklyFeatureFlags: object,
    mutate: func,
    showSlideout: func,
    hideSlideout: func,
    setSelectedYearOverYearData: func,
    setYearOverYearDisplayIn: func,
    initializeAgreement: func,
    validateSession: func,
    loadJobDetails: func,
    launchEditJobSlideout: func,
    addJob: func,
    setSelectedBenchmarkYear: func,
    setDisplayIn: func,
    getJobsByID: func,
    setSelectedSkillGeoDifferentialData: func,
    setSelectedMigrationData: func,
    setSMAData: func,
    setBulkCopyData: func,
    setStrucBulkCreateGridStore: func,
    participationCenterReview: object,
    organization: object,
    initParticipationMatchReview: func,
    resetParticipationMatchReview: func,
    loadParticipationMatchReviewItems: func,
    slideout: shape({
      open: bool,
      slideoutType: object
    }),
    getMarketplaceMatches: func,
    resetMarketplaceMatches: func,
    getJobPricingDetails: func,
    jobPricingSearch: func,
    applyWeighting: func,
    resetApplyWeighting: func,
    getApplyWeightingCounts: func,
    applyWeightingReducer: shape({
      loading: bool,
      countWithZero: number,
      countWithoutZero: number,
      error: string,
      loaded: bool
    }),
    defaultBenchmarkYear: number,
    getSessionData: func
  };

  constructor(props) {
    super(props);
    this.frameMessage = this.frameMessage.bind(this);
    this.handleParticipationGenerateReports = this.handleParticipationGenerateReports.bind(this);
    this.handleSurveyLibraryUpdateAgreement = this.handleSurveyLibraryUpdateAgreement.bind(this);
    this.handleEasySurveyMigration = this.handleEasySurveyMigration.bind(this);
    this.handleRemoveSurveysSlideout = this.handleRemoveSurveysSlideout.bind(this);
    this.participationMatchReviewShowSlideout = this.participationMatchReviewShowSlideout.bind(this);
    this.participationMatchReviewLoadData = this.participationMatchReviewLoadData.bind(this);
    this.participationMatchReviewOpenReport = this.participationMatchReviewOpenReport.bind(this);
    this.participationMatchReviewCloseSlideout = this.participationMatchReviewCloseSlideout.bind(this);
    this.getParticipationMatchReportURL = this.getParticipationMatchReportURL.bind(this);
    this.getParticipationMatchSupportURL = this.getParticipationMatchSupportURL.bind(this);
    this.closeJDXSettingsModal = this.closeJDXSettingsModal.bind(this);
    this.triggerJDXSettingsModal = this.triggerJDXSettingsModal.bind(this);
    this.closeDefaultWeightModal = this.closeDefaultWeightModal.bind(this);
    this.triggerDefaultWeightModal = this.triggerDefaultWeightModal.bind(this);

    this.state = {
      groupId: props.session.group.id,
      currencyCode: props.session.currency.code,
      iFrameLoading: null,
      showJDXSettingsModal: false,
      showDefaultWeightModal: false,
      selectedDefaultWeighting: props.session.defaultWeighting
    };
    this.historyData = {};
  }

  componentDidMount() {
    this.setState({ iFrameLoading: true, location: this.props.location });
    window.addEventListener('message', this.frameMessage);
  }

  UNSAFE_componentWillUnmount() {
    this.setState({ iFrameLoading: null });
    window.removeEventListener('message', this.frameMessage);

    const iframe = document.querySelector('iframe.frame-iframe').contentWindow;
    iframe.removeEventListener('click', e => this.iFrameClickHandler(e));
    iframe.removeEventListener('click', this.debounceOnAction());
    iframe.removeEventListener('wheel', this.debounceOnAction());
    iframe.removeEventListener('keypress', this.debounceOnAction());
    iframe.removeEventListener('mousemove', this.debounceOnAction());
    iframe.removeEventListener('mousedown', this.debounceOnAction());
    iframe.removeEventListener('resize', this.debounceOnAction());
    iframe.removeEventListener('focus', this.debounceOnAction());
    iframe.removeEventListener('blur', this.debounceOnAction());
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.groupId !== nextProps.session.group.id ||
      this.state.currencyCode !== nextProps.session.currency.code
    ) {
      this.setState({
        groupId: nextProps.session.group.id,
        currencyCode: nextProps.session.currency.code
      });
    }

    const pathChanged = this.props.location.pathname !== nextProps.location.pathname;
    if (pathChanged) {
      this.setState({ location: nextProps.location });
    }

    if (!this.state.location) {
      // location not yet set so iframe not rendered
      return;
    }

    //  TODO: This might need to be cleaned up; however, the goal is to determine if the underlying iframe URL
    //  changes on a URL property change and avoid showing the loading indicator if the underlying iframe content
    //  did not change. This is causing an issue for MPE-4424 with Participation center as well as the new
    //  Survey Migration slideout due to the URL changing with the hash (#) route changes. Not having this logic
    //  would cause the IFrame to think something is loading when it is not since the content was already loaded in the
    //  iframe, but the slideout overlay was the thing that had changed.
    const iframe = this.getIFrame();

    const iframePathname = iframe.location.pathname ? iframe.location.pathname : '';
    const iframeSearch = iframe.location.search ? iframe.location.search : '';
    const iframeEndPath = `${iframePathname}${iframeSearch}`;

    const newSearch = nextProps.location.search ? iframe.location.search : '';

    if (
      pathChanged &&
      this.shouldIFrameLoad(iframePathname, 'migration/migrate') &&
      this.shouldIFrameLoad(iframeEndPath, `pcenter/pcenter-2${newSearch}`) &&
      this.shouldIFrameLoad(iframePathname, '/edit')
    ) {
      this.setState({ iFrameLoading: true });
    }
  }

  /**
   * This is a workaround for being able to avoid the iframe loading indicator showing up when
   * updating the routing history with support for the slideouts which would cause the URL to change but the
   * underlying iframe URL to stay the same.
   *
   * @param iframeURL iframe URL
   * @param matchPostfixIframeURL matching iframe URL postfix condition
   */
  shouldIFrameLoad(iframeURL, matchPostfixIframeURL) {
    return !iframeURL.endsWith(matchPostfixIframeURL);
  }

  getIFrame() {
    return document.querySelector('iframe.frame-iframe').contentWindow;
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { location, history } = this.props;
    const hasSlideoutUrl = this.hasSlideoutUrl(location.hash) || this.hasSlideoutUrl(nextProps.location.hash);
    const historyHasModalUrl = history.action === 'PUSH' && this.hasModalUrl(history.location.pathname);
    const currentReviewStatus = this.props.participationCenterReview.reviewStatus;
    const nextReviewStatus = nextProps.participationCenterReview.reviewStatus;
    const nextShowJDXSettingsModal = nextState.showJDXSettingsModal;

    if (nextShowJDXSettingsModal !== this.state.showJDXSettingsModal || nextReviewStatus !== currentReviewStatus) {
      return true;
    }

    if (nextState.showDefaultWeightModal !== this.state.showDefaultWeightModal) {
      return true;
    }

    if (nextProps.applyWeightingReducer !== this.props.applyWeightingReducer) {
      return true;
    }

    if (location.pathname.includes(nextProps.location.pathname) && location.search === nextProps.location.search) {
      // Update loading indicator
      if (this.state.iFrameLoading !== nextState.iFrameLoading) {
        return true;
      }
      // location url/params hasn't changed, don't update
      return false;
    }

    if (nextProps.history.location.pathname.endsWith('/job-description')) return false;

    if (!hasSlideoutUrl && !historyHasModalUrl) {
      // no slideout url, or modal url in next location, allow update
      return true;
    }

    if (historyHasModalUrl) {
      // If there is a modal URL, don't update
      return false;
    }

    // other conditions not met, allow update
    return true;
  }

  componentDidUpdate(prevProps, prevState) {
    const { participationCenterReview } = this.props;
    const currentReviewStatus = participationCenterReview.reviewStatus;
    const prevReviewStatus = prevProps.participationCenterReview.reviewStatus;
    if (currentReviewStatus !== prevReviewStatus) {
      switch (participationCenterReview.reviewStatus) {
        case REVIEW_STATUS_IN_REVIEW:
        case REVIEW_STATUS_LOAD_ERROR:
        case REVIEW_STATUS_NO_REVIEW:
          this.participationMatchReviewShowSlideout();
          break;
        default:
          break;
      }
    }
  }

  // Returns true if there is a modal address in the current location, else false
  // TODO We'll need to expand this to match the slideoutAddresses
  // If we add more modals that spawn out of the IFrame
  hasModalUrl(url) {
    if (url.includes('/compensation-summary-report')) {
      return true;
    }

    if (url.includes('/side-by-side')) {
      return true;
    }

    if (url.includes('/edit')) {
      return true;
    }

    return false;
  }

  // Returns true if there is a slideout address in the current location, else false
  hasSlideoutUrl(hash) {
    if (hash === '') return false;

    let hasSlideoutUrl = false;
    for (let i = 0; i < slideoutAddresses.length; i++) {
      let address = slideoutAddresses[i];
      if (hash.indexOf(address) > -1) {
        hasSlideoutUrl = true;
        break;
      }
    }

    return hasSlideoutUrl;
  }

  handleParticipationGenerateReports = (event, gridSettings) => {
    const iframe = this.getIFrame();
    const targetEvent = event.target;

    if (targetEvent.id && targetEvent.id.startsWith('merit-pcenter-2-generate-report-button')) {
      const reportCombo = iframe.window.Ext.getCmp('merit-pcenter-2-data-submission-report-combo');
      const reportType = reportCombo.getValue();

      if (reportType === 'Data Submission Report') {
        const pubSurveySourceId = gridSettings.pub_survey_source_id;
        this.props.location.search = `?pub_survey_source_id=${pubSurveySourceId}`;
        this.participationMatchReviewShowSlideout();

        event.preventDefault();
        return true;
      }
    }
    return false;
  };

  handleSurveyLibraryUpdateAgreement = (event, showSlideout, hideSlideout, initializeAgreement) => {
    const iframe = this.getIFrame();
    const targetEvent = event.target;

    if (targetEvent.id && targetEvent.id.startsWith('survey-library-update-submit-agreement')) {
      initializeAgreement();
      showSlideout(MarketPaySlideouts.SLU_AGREEMENT_SLIDEOUT);
      return true;
    }
    return false;
  };

  handleShowCrowdSourcedMarketPricing = targetEvent => {
    const { showSlideout } = this.props;
    const crowdSourceButtonText = 'Crowd-Sourced Match';

    if (
      targetEvent.srcElement.innerText === crowdSourceButtonText ||
      targetEvent.srcElement.parentElement?.innerText === crowdSourceButtonText ||
      (targetEvent.data && targetEvent.data === crowdSourceButtonText)
    ) {
      const iframe = this.getIFrame();
      const activeTab = iframe.window.app.getController('pricingTabLauncher').getActiveJobTab();
      const benchmarkYear = activeTab.query('benchmarkSummaryCombo')[0].getValue();
      const jobData = activeTab.job_data;

      showSlideout(MarketPaySlideouts.CROWD_SOURCED_MARKET_PRICING, {
        benchmarkYear: benchmarkYear,
        orgJobCode: jobData.job_code,
        orgJobCodeKey: jobData.job_code_key,
        orgJobCurrency: jobData.currency,
        orgJobId: jobData.org_job_id,
        orgJobTitle: jobData.job_title,
        refreshJobTabData: this.refreshJobTabData
      });

      return true;
    }

    return false;
  };

  handleAddPrivateSurveyJobButton = event => {
    const { session, showSlideout } = this.props;
    const privateSurveyJobBPageButtonId = 'add_private_survey_job';
    if (event?.target?.id?.includes(privateSurveyJobBPageButtonId)) {
      showSlideout(MarketPaySlideouts.PRIVATE_SURVEY_JOB_MATCH, {
        benchmarkYear: session.benchmarkYear,
        currencies: session.currencies,
        currency: session.currency?.code,
        fromIframe: true,
        refreshPrivateSurveyJobTabData: this.refreshPrivateSurveyJobTabData
      });

      return true;
    } else if (event?.data === 'add-private-survey-job') {
      const iframe = this.getIFrame();
      const activeTab = iframe.window.app.getController('pricingTabLauncher').getActiveJobTab();
      const jobData = activeTab.job_data;

      showSlideout(MarketPaySlideouts.PRIVATE_SURVEY_JOB_MATCH, {
        benchmarkYear: session.benchmarkYear,
        currencies: session.currencies,
        currency: session.currency?.code,
        orgJobCode: jobData.job_code,
        orgJobCurrency: jobData.currency,
        orgJobCodeKey: jobData.job_code_key,
        orgJobId: jobData.org_job_id,
        fromIframe: true,
        fromJobDetails: true,
        refreshJobTabData: this.refreshJobTabData
      });

      return true;
    }

    return false;
  };

  handleAddPrivateSurveyButton = event => {
    const { session, showSlideout } = this.props;
    const privateSurveySourceButtonId = 'add_new_survey_source';
    const surveyLibActiveButtonId = 'survey_library_active__add_new_survey_source';
    const surveyLibNotActiveButtonId = 'survey_library_archived__add_new_survey_source';

    if (event.target.id.includes(surveyLibActiveButtonId) || event.target.id.includes(surveyLibNotActiveButtonId)) {
      showSlideout(MarketPaySlideouts.PRIVATE_SURVEY, {
        fromIframe: true,
        refreshPrivateSurveyTabData: this.refreshSurveyTabData
      });

      return true;
    } else if (event.target.id.includes(privateSurveySourceButtonId)) {
      showSlideout(MarketPaySlideouts.PRIVATE_SURVEY, {
        fromIframe: true,
        refreshPrivateSurveyTabData: this.refreshPrivateSurveyTabData
      });

      return true;
    }

    return false;
  };

  handleMarketplaceMatches = (
    targetEvent,
    gridSettings,
    showSlideout,
    getMarketplaceMatches,
    resetMarketplaceMatches,
    getJobPricingDetails,
    session,
    jobPricingSearch
  ) => {
    if (targetEvent?.data === 'open-mpm-slideout') {
      const { groupId } = this.state;
      const iframe = this.getIFrame();
      const activeTab = iframe.window.app.getController('pricingTabLauncher').getActiveJobTab();
      const jobData = activeTab.job_data;
      const payDivisor = jobData.pay_divisor;
      const displayIn = getDisplayInFromPayDivisor(payDivisor);
      const isAdhoc = !gridSettings.adhoc_hidden;
      const benchmarkYear = activeTab.query('benchmarkSummaryCombo')[0].getValue();
      const status = jobData.slot_p;

      const price3grid = activeTab.query('price3_grid')[0];
      const priceStore = price3grid.getStore();
      const indexMap = priceStore?.data?.indexMap;

      const searchMatchesTabs = activeTab.query('searchMatchesTabs')[0];
      const selectedViewPk = searchMatchesTabs.activeTab.gridData.view_pk;

      const { org_job_id, job_code, job_code_key, currency } = jobData;

      // reset and reload recommendations every time the slideout is opened
      resetMarketplaceMatches();
      getJobPricingDetails(
        { code: job_code, codeKey: job_code_key, currency },
        benchmarkYear,
        displayIn,
        jobPricingSearch,
        session.organization.masterAccountId
      );

      showSlideout(MarketPaySlideouts.MARKETPLACE_MATCHES, {
        benchmarkYear,
        currency,
        displayIn,
        groupId,
        indexMap,
        isAdhoc,
        status,
        jobCode: job_code,
        jobCodeKey: job_code_key,
        jobId: org_job_id,
        refreshJobTabData: this.refreshJobTabData,
        selectedViewPk,
        launchDarklyFeatureFlags: this.props.launchDarklyFeatureFlags
      });

      return true;
    }

    return false;
  };

  handleRemoveSurveysSlideout = event => {
    const { showSlideout } = this.props;
    if (event?.target?.id?.startsWith('remove_not_active_surveys')) {
      showSlideout(MarketPaySlideouts.NOT_ACTIVE_SURVEYS, { refreshSurveyTabData: this.refreshSurveyTabData });

      return true;
    }

    return false;
  };

  handleDataCutMigrationLink = event => {
    const { history } = this.props;
    if (event?.target?.id === 'migration-set-up') {
      event.preventDefault();
      history.push('/market-analysis/data-cut-migration');
      return true;
    }
    return false;
  };

  handleEasySurveyMigration = event => {
    const { setSelectedMigrationData, showSlideout } = this.props;
    const iframe = this.getIFrame();
    const targetEvent = event.target;

    if (targetEvent.id && targetEvent.id.startsWith('survey-migration-easy-match-button')) {
      const migrateButton = iframe.window.Ext.getCmp('survey-migration-easy-match-button');
      if (!migrateButton || migrateButton.isDisabled()) {
        return false;
      }

      // Set target years for migration slide-out
      const oldSurvey = iframe.window.gridSettings.current_survey_year;
      const newSurvey = iframe.window.gridSettings.new_survey_year;
      const gridStore = iframe.window.Ext.ComponentQuery.query('migrateMatchesTab')[0].getStore();
      let noneSelected = true;
      gridStore.each(function(record) {
        noneSelected = noneSelected && !record.get('include_survey');
      });
      if (noneSelected) {
        /**
         * Add future logic to potentially open a selection menu
         * To choose between using old or new migration
         */
      } else {
        setSelectedMigrationData(
          parseInt(oldSurvey),
          parseInt(newSurvey),
          iframe.window.Ext.ComponentQuery.query('migrateMatchesTab')[0].getStore()
        );
        showSlideout(MarketPaySlideouts.SURVEY_MIGRATION_SLIDEOUT);
      }
      return true;
    }
    return false;
  };

  handleStructureModelingAnalyticsSlideout = event => {
    const targetEvent = event.target;
    if (targetEvent.id?.startsWith('open_analytics_slideout')) {
      const iframe = this.getIFrame();
      const { model_id } = iframe.window.gridSettings;
      const { showSlideout } = this.props;
      this.props.setSMAData(model_id);
      showSlideout(MarketPaySlideouts.STRUCTURE_MODELING_ANALYTICS_SLIDEOUT);
      return true;
    }
    return false;
  };

  handleStructureModelingLink = event => {
    const { history } = this.props;
    if (event?.target?.innerText === 'Model a Structure' && history.location.state?.fromStructureModeling) {
      event.preventDefault();
      history.push('/structure-modeling');
      return true;
    }
    return false;
  };

  closeJDXSettingsModal = () => {
    this.setState({
      showJDXSettingsModal: false
    });
  };

  triggerJDXSettingsModal = () => {
    this.setState({
      showJDXSettingsModal: true
    });
  };

  closeDefaultWeightModal = () => {
    this.setState({
      showDefaultWeightModal: false
    });
  };

  triggerDefaultWeightModal = () => {
    const { resetApplyWeighting, getApplyWeightingCounts } = this.props;

    resetApplyWeighting();
    getApplyWeightingCounts();

    this.setState({
      showDefaultWeightModal: true
    });
  };

  handleJobDescriptionSlideout = () => {
    const { showSlideout, history, launchDarklyFeatureFlags } = this.props;
    const iframe = this.getIFrame();
    const controllerList = iframe.window.app.controllers.keys;
    let jobData;
    if (controllerList.includes('pricingTabLauncher')) {
      jobData = iframe.window.app.getController('pricingTabLauncher').getActiveJobTab().job_data;
    } else if (controllerList.includes('tabLauncher')) {
      jobData = iframe.window.app.getController('tabLauncher');
      jobData = {
        org_job_id: jobData.org_job_id,
        job_code: jobData.org_job_code,
        job_code_key: jobData.org_job_code_key,
        job_title: jobData.org_job_title
      };
    }
    if (jobData) {
      const { org_job_id, job_title, job_code, job_code_key } = jobData;
      showSlideout(MarketPaySlideouts.JOB_DESCRIPTION_SLIDEOUT, {
        backToRoute: history.location.pathname,
        orgJobId: org_job_id,
        orgJobCode: job_code,
        orgJobCodeKey: job_code_key,
        orgJobTitle: job_title,
        launchDarklyFeatureFlags
      });
      history.push(`${history.location.pathname}/job-description`);
    }
  };

  handleSideBySideDescriptionModal = () => {
    const iframe = this.getIFrame();
    const controllerList = iframe.window.app.controllers.keys;
    let backToText = 'Market Pricing';
    let jobData, orgJobCode, orgJobCodeKey;
    if (controllerList.includes('pricingTabLauncher')) {
      jobData = iframe.window.app.getController('pricingTabLauncher').getActiveJobTab().job_data;
      orgJobCode = jobData.job_code;
      orgJobCodeKey = jobData.job_code_key;
      backToText = 'Market Pricing';
    } else if (controllerList.includes('tabLauncher')) {
      jobData = iframe.window.app.getController('tabLauncher');
      orgJobCode = jobData.org_job_code;
      orgJobCodeKey = jobData.org_job_code_key;
      backToText = 'Job View';
    }
    this.props.history.push(`${this.props.history.location.pathname}/side-by-side`, {
      modal: true,
      modalType: 'JDX_IFRAME',
      modalProps: {
        backToRoute: this.props.history.location.pathname,
        className: 'jdexpert__modal',
        jdxAction: jdxActions.SIDE_BY_SIDE,
        titleText: jdxTitles.SIDE_BY_SIDE,
        backToText,
        currentJob: {
          code: orgJobCode,
          codeKey: orgJobCodeKey
        },
        hideClose: true,
        launchDarklyFeatureFlags: this.props.launchDarklyFeatureFlags
      },
      component: 'JDX_IFRAME'
    });
  };

  /**
   * Handles the legacy (Sencha) behavior for the migrate easy matches button.
   * This logic can be removed once all of the Survey Migration work has been completed and the survey
   * migration landing page (grid view) has been replaced & depreciated.
   *
   * This was ported from merit/www/migration/controller/migrateMatchesMgr.js
   */
  handleEasySurveyMigrationLegacy = (Ext, gridSettings) => {
    let migrate_p;
    let migrate_survey_list = [];
    let old_survey;
    let new_survey;
    let survey_pair = [];

    Ext.Msg.show({
      title: 'Migrate Matches',
      msg:
        'This action will migrate all available matches for all checked surveys, and update the match summary information. You will receive an email when the process is complete. Once the migration is complete, be sure and refresh the Migration Set-up page to ensure that you are viewing the most up-to-date record counts.',
      buttons: Ext.Msg.OKCANCEL,
      fn: function(btn) {
        if (btn == 'ok') {
          let gridStore = Ext.ComponentQuery.query('migrateMatchesTab')[0].getStore();
          let migrate_survey_list = [];
          let migrate_survey_list_json = [];

          gridStore.each(function(record, idx) {
            old_survey = record.get('old_survey_code');
            new_survey = record.get('new_survey_code');

            migrate_p = record.get('include_survey');
            if (migrate_p) {
              let survey_pair = [];
              survey_pair.push(old_survey);
              survey_pair.push(new_survey);
              migrate_survey_list.push(survey_pair);
            }
          });

          migrate_survey_list_json = Ext.JSON.encode(migrate_survey_list);
          Ext.Ajax.request({
            url: 'set-matches-perm',
            params: {
              survey_list: migrate_survey_list_json,
              current_survey_year: gridSettings.current_survey_year,
              new_survey_year: gridSettings.new_survey_year
            },
            success: function(response, opts) {
              //msgBox.hide();
              //Ext.MessageBox.hide();
              Ext.Msg.alert('Status', 'Matches migrated');
              gridStore.proxy.extraParams.current_survey_year = gridSettings.current_survey_year;
              gridStore.proxy.extraParams.new_survey_year = gridSettings.new_survey_year;
              gridStore.load({
                callback: function(records, operation, success) {
                  migrate_survey_list.forEach(function(rec, idx) {
                    gridStore.getAt(gridStore.findExact('old_survey_code', rec[0])).set({ include_survey: true });
                  });
                }
              });
            }
          });
        }
      }
    });
  };

  iFrameMessageHandler = event => {
    const {
      addJob,
      getJobsByID,
      setDisplayIn,
      setSelectedBenchmarkYear,
      showSlideout,
      history,
      getMarketplaceMatches,
      resetMarketplaceMatches,
      getJobPricingDetails,
      session,
      jobPricingSearch,
      defaultBenchmarkYear
    } = this.props;

    const iframe = document.querySelector('iframe.frame-iframe').contentWindow;
    const gridSettings = iframe.window.gridSettings;

    if (event.data === 'system-config-updated') {
      this.props.getSessionData(true);
      return;
    }

    if (event.data == 'Add crowd-sourced match') {
      this.handleShowCrowdSourcedMarketPricing(event);
      return;
    }

    if (event.data === 'open-mpm-slideout') {
      this.handleMarketplaceMatches(
        event,
        gridSettings,
        showSlideout,
        getMarketplaceMatches,
        resetMarketplaceMatches,
        getJobPricingDetails,
        session,
        jobPricingSearch
      );
      return;
    }

    if (event.data === 'open-pcenter-yoy-slideout') {
      showSlideout(MarketPaySlideouts.PARTICIPATION_REPORT_SLIDEOUT, {})
      return;
    }

    if (event.data === 'open-job-description-slideout') {
      this.handleJobDescriptionSlideout();
      return;
    }

    if (event.data === 'open-sub-family-job-description-modal') {
      this.handleSideBySideDescriptionModal();
      return;
    }

    if (event.data.includes('open-default-weighting')) {
      this.setState({ selectedDefaultWeighting: event.data.replace('open-default-weighting-', '') });
      this.triggerDefaultWeightModal();
    }

    if (event.data.includes('add-private-survey-job')) {
      this.handleAddPrivateSurveyJobButton(event);
      return;
    }

    if (
      event.data != 'Compensation Summary' &&
      event.data != 'Compensation Summary Multiple' &&
      event.data !== 'view-advanced-settings'
    )
      return;

    let showCSR = false;
    let orgJob;

    if (event.data === 'view-advanced-settings') {
      this.triggerJDXSettingsModal();
    } else if (event.data === 'Compensation Summary') {
      const activeTab = iframe.window.app.getController('pricingTabLauncher').getActiveJobTab();
      const benchmarkYear = activeTab.query('benchmarkSummaryCombo')[0].getValue();
      const jobData = activeTab.job_data;
      const orgJobCode = jobData.job_code;
      const orgJobCodeKey = jobData.job_code_key;
      const orgJobId = jobData.org_job_id;
      const payDivisor = jobData.pay_divisor;
      const displayIn = getDisplayInFromPayDivisor(payDivisor);
      if (jobData.job_title !== 'Adhoc pricing') {
        showCSR = true;
        orgJob = {
          id: orgJobId,
          orgJobId: orgJobId,
          code: orgJobCode,
          codeKey: orgJobCodeKey
        };

        addJob(orgJob);
        setSelectedBenchmarkYear(benchmarkYear);
        setDisplayIn(displayIn);
      }
    } else {
      const input = iframe.window.input;
      const selectedJobs = iframe.window.Ext.ComponentQuery.query('pricing_grid')[0]
        .getSelectionModel()
        .getSelection();

      const jobIds = selectedJobs.map(job => {
        return job.raw[input.job_id_field_name];
      });

      setSelectedBenchmarkYear(defaultBenchmarkYear);

      showCSR = true;
      getJobsByID(jobIds);
      orgJob = {
        id: jobIds[0]
      };
    }

    if (showCSR) {
      event.preventDefault();
      const activeTab = iframe.window.app.getController('pricingTabLauncher').getActiveJobTab();
      const viewName = activeTab ? activeTab.query('[cls~=viewcombo]')[0].rawValue : null;
      setViewName(viewName);

      const surveyTab = iframe.window.Ext.ComponentQuery.query('searchMatchesTabs')[0].getActiveTab();
      const surveyViewName = surveyTab ? surveyTab.query('[cls~=viewcombo]')[0].rawValue : null;

      if (!history.location.pathname.includes('compensation-summary-report')) {
        history.push(`${history.location.pathname}/jobs/${orgJob.id}/compensation-summary-report`, {
          modal: true,
          modalType: 'COMPENSATION_SUMMARY_REPORT',
          modalProps: {
            className: 'comp-sum__modal',
            orgJob,
            viewName,
            surveyViewName,
            launchDarklyFeatureFlags: this.props.launchDarklyFeatureFlags
          },
          component: 'COMPENSATION_SUMMARY_REPORT'
        });
      }
    }
  };

  iFrameClickHandler = event => {
    const {
      showSlideout,
      hideSlideout,
      initializeAgreement,
      setSelectedYearOverYearData,
      setYearOverYearDisplayIn,
      history
    } = this.props;

    const refreshJobTabData = this.refreshJobTabData;

    const iframe = document.querySelector('iframe.frame-iframe').contentWindow;
    const gridSettings = iframe.window.gridSettings;
    const targetEvent = event.target;

    if (this.handleShowCrowdSourcedMarketPricing(event)) return;
    if (this.handleSurveyLibraryUpdateAgreement(event, showSlideout, hideSlideout, initializeAgreement)) return;
    if (this.handleParticipationGenerateReports(event, gridSettings)) return;
    if (this.handleEasySurveyMigration(event, showSlideout, hideSlideout)) return;
    if (this.handleStructureModelingAnalyticsSlideout(event, showSlideout, hideSlideout)) return;
    if (this.handleRemoveSurveysSlideout(event)) return;
    if (this.handleDataCutMigrationLink(event)) return;
    if (this.handleStructureModelingLink(event)) return;
    if (this.handleAddPrivateSurveyJobButton(event)) return;
    if (this.handleAddPrivateSurveyButton(event)) return;
    // This is a hack to intercept the only the "assign salary range" link click event within the iFrame.
    const targetInnerText = targetEvent.innerText;
    const isSalaryRangeText = targetInnerText === 'assign salary range';
    let isYoYButton = targetInnerText === 'Year Over Year';
    let isSkillGeoDifferentialButton = targetInnerText === 'Differentials';
    const isSurveyLibraryChangeButton = targetInnerText === 'Survey Library Change';

    if (isSalaryRangeText) {
      event.preventDefault();
      const activeTab = iframe.window.app.getController('pricingTabLauncher').getActiveJobTab();
      const orgJobId = activeTab.job_data.org_job_id;
      showSlideout(MarketPaySlideouts.SALARY_RANGE_SLIDEOUT, { orgJobId: orgJobId });
    } else if (isYoYButton) {
      // Use Sencha to pull out the values
      const activeTab = iframe.window.app.getController('pricingTabLauncher').getActiveJobTab();
      const benchmarkYear = activeTab.query('benchmarkSummaryCombo')[0].getValue();
      const jobData = activeTab.job_data;
      const hideJobCodeKey = jobData.hide_job_code_key;
      const jobCodeKeyText = jobData.job_code_key_text;
      const orgJobCode = jobData.job_code;
      const orgJobCodeKey = jobData.job_code_key;
      const jobTitle = jobData.job_title;
      const currency = jobData.currency;
      const orgJobId = jobData.org_job_id;
      const payDivisor = jobData.pay_divisor;
      const displayIn = getDisplayInFromPayDivisor(payDivisor);

      event.preventDefault();

      setSelectedYearOverYearData(
        orgJobId,
        orgJobCode,
        orgJobCodeKey,
        benchmarkYear,
        currency,
        jobTitle,
        hideJobCodeKey,
        jobCodeKeyText,
        displayIn
      );
      setYearOverYearDisplayIn(displayIn);

      showSlideout(MarketPaySlideouts.YEAR_OVER_YEAR);
    } else if (isSkillGeoDifferentialButton) {
      event.preventDefault();
      const activeTab = iframe.window.app.getController('pricingTabLauncher').getActiveJobTab();
      const benchmarkYear = activeTab.query('benchmarkSummaryCombo')[0].getValue();
      const jobData = activeTab.job_data;
      const orgJobCode = jobData.job_code;
      const orgJobCodeKey = jobData.job_code_key;
      const jobTitle = jobData.job_title;
      const currency = jobData.currency;
      const orgJobId = jobData.org_job_id;
      const payDivisor = jobData.pay_divisor;
      const displayIn = getDisplayInFromPayDivisor(payDivisor);

      event.preventDefault();

      showSlideout(MarketPaySlideouts.SKILL_GEO_DIFFERENTIAL, {
        orgJobId,
        orgJobCode,
        orgJobCodeKey,
        currency,
        jobTitle,
        benchmarkYear,
        displayIn,
        refreshJobTabData
      });
    } else if (isSurveyLibraryChangeButton) {
      history.push('/market-analysis/survey-library/marketpay-library');
    }
  };

  frameMessage(e) {
    if (e.data && e.data.type) {
      switch (e.data.type) {
        // eslint-disable-next-line no-case-declarations
        case 'goback':
          // MPE-2407 and MPE-2317: Clicking 'Report Writer' breadcrumb for reports should go to '/reports/library'
          const iframe = document.querySelector('iframe.frame-iframe')?.contentWindow;

          // if current location is the root 'reports/library' page, then do not go back further
          if (location.pathname.endsWith('/reports/library')) {
            break;
          }

          const reportController = iframe.window?.app?.getController('ReportWriter');
          // if the ReportWriter controller exists, can assume it's a report
          if (reportController) {
            this.props.history?.push({
              pathname: '/reports/library',
              state: {
                history: this.historyData
              }
            });
            break;
          }

          // default goback logic for any non-report-writer breadcrumb links
          if (this.props.location?.state?.history) {
            this.props.history?.push({
              pathname: this.props.location.state.history,
              state: {
                history: this.historyData
              }
            });
          } else {
            this.props.history?.goBack();
          }

          break;
        case 'updateThumbnailCache':
          // this can be called multiple times, check if report
          // and workbook are different before calling again
          this.props
            .mutate({
              variables: {
                id: e.data.reportId,
                workbook: { id: e.data.workbookId }
              }
            })
            .catch(() => {});
          break;
        case 'systemconfig':
          this.props.getSessionData(true);
          break;
        default:
          this.historyData = e.data;
          break;
      }
    }
  }

  setLoaded = () => {
    this.setState({ iFrameLoading: false });

    const iframe = document.querySelector('iframe.frame-iframe').contentWindow;
    const orgCode = this.props.session.organization.code;

    if (iframe.location.pathname === `/oauth/${orgCode}/login`) {
      this.props.validateSession();
    } else {
      iframe.addEventListener('click', e => this.iFrameClickHandler(e));
      iframe.addEventListener('message', this.iFrameMessageHandler, false);
      // Listen for any activity indicating the user is active
      iframe.addEventListener('click', this.debounceOnAction());
      iframe.addEventListener('wheel', this.debounceOnAction());
      iframe.addEventListener('keypress', this.debounceOnAction());
      iframe.addEventListener('mousemove', this.debounceOnAction());
      iframe.addEventListener('mousedown', this.debounceOnAction());
      iframe.addEventListener('resize', this.debounceOnAction());
      iframe.addEventListener('focus', this.debounceOnAction());
      iframe.addEventListener('blur', this.debounceOnAction());

      if (localStorage.fromGlobalJobMatching && this.props.history.length === 1) {
        if (localStorage.getItem('fromGlobalJobMatching') !== null) {
          localStorage.removeItem('fromGlobalJobMatching');
        }

        if (iframe.window.Ext && window.location.pathname.includes('iframe/merit/merit-admin/survey_lib')) {
          let dataCutsWindow = iframe.Ext.ComponentQuery.query('DataCutsWindow')[0];
          if (!dataCutsWindow) {
            dataCutsWindow = iframe.Ext.create('MP.DataCutsWindow');
            iframe.Ext.ComponentQuery.query('SurveyPanel')[0]
              .getStore()
              .load();
          }
          dataCutsWindow.show();
          const grid = iframe.Ext.ComponentQuery.query('DataCutPanel')[0];
          grid.getStore().removeAll();
        }
      }
    }
  };

  debounceOnAction() {
    return debounce(this.props.onAction, 1000, { leading: true });
  }

  logClickEvent = event => {
    // console.log('iframe click event: ', event);
  };

  participationMatchReviewShowSlideout = () => {
    // this.participationMatchReviewErrorModal.show(); return;
    //  NOTE: There are 4 different states that can occur in this step
    //    STATE #1: Uninitialized review data
    //    STATE #2: Error when retrieving matches, should show an error popup
    //    STATE #3: No errors & has matches to review, should open up the slideout
    //    STATE #4: No errors & no matches, should open up the report URL
    const { showSlideout, participationCenterReview } = this.props;
    const { reviewStatus, initialized } = participationCenterReview;

    if (!initialized) {
      this.participationMatchReviewLoadData();
      return;
    }

    switch (reviewStatus) {
      //  State #2: Data fetch failed, show the error popup
      case REVIEW_STATUS_LOAD_ERROR:
        this.participationMatchReviewErrorModal.show();
        break;
      //  State #3: No errors but has matches to review, open the slideout
      case REVIEW_STATUS_IN_REVIEW:
        this.participationMatchReviewErrorModal.hide();
        showSlideout(CommonSlideouts.PARTICIPATION_CENTER_MATCH_REVIEW_SLIDEOUT, {
          hideSlideout: this.participationMatchReviewCloseSlideout
        });
        break;
      // //  State #4: No errors or matches to review, open the report tab
      case REVIEW_STATUS_NO_REVIEW:
        this.participationMatchReviewOpenReport();
        break;
    }
  };

  participationMatchReviewLoadData = () => {
    this.participationMatchReviewErrorModal.hide();

    //  get survey source id and do nothing if it cannot be found
    const surveySourceId = this.parseUrlSurveySourceId(this.props.location.search);
    if (!surveySourceId && surveySourceId !== 0) return;

    const reportUrl = this.getParticipationMatchReportURL();
    const supportUrl = this.getParticipationMatchSupportURL();

    //  State #1: review has not begun
    this.props.initParticipationMatchReview(reportUrl, supportUrl, true);
    this.props.loadParticipationMatchReviewItems(surveySourceId);
  };

  participationMatchReviewOpenReport = () => {
    //  get survey source id and do nothing if it cannot be found
    const surveySourceId = this.parseUrlSurveySourceId(this.props.location.search);
    if (!surveySourceId && surveySourceId !== 0) return;

    window.open(this.getParticipationMatchReportURL());
    this.participationMatchReviewErrorModal.hide();
    this.participationMatchReviewCloseSlideout();
  };

  participationMatchReviewCloseSlideout = () => {
    const { hideSlideout, resetParticipationMatchReview } = this.props;
    this.participationMatchReviewErrorModal.hide();
    resetParticipationMatchReview();
    hideSlideout();
  };

  getParticipationMatchReportURL = () => {
    const search = this.props.location.search;
    const orgCode = this.props.organization.code;
    return `${window.location.origin}/view/o/${orgCode}/mp/iframe/merit/pcenter/pcenter-reports${search}`;
  };

  getParticipationMatchSupportURL = () => {
    return {
      ...this.props.location,
      hash: LINK_HASH_SUPPORT_CONTACT
    };
  };

  parseUrlSurveySourceId = search => {
    const searchArray = search ? search.split('?pub_survey_source_id=') : [];
    if (searchArray.length !== 2 || isNaN(searchArray[1])) {
      //  this is an unsupported case if the source id cannot be found
      return;
    }

    return parseInt(searchArray[1]);
  };

  propsToIframeSrc = () => {
    const params = this.props.match.params;
    const orgCode = this.props.session.organization.code;
    const meritRoute = params.meritroute;
    let path;
    if (params.path) {
      path = params.path + (params.subroute ? `/${params.subroute}` : '');
    }
    let pageUrl;
    // if there's a merit route use the open acs host
    if (meritRoute) {
      pageUrl = `${this.props.config.openACSHost}/`;
    } else {
      pageUrl = '/';
    }

    if (orgCode && meritRoute !== 'mphelp') {
      pageUrl += `${orgCode}/`;
    }

    if (meritRoute) {
      // the "app/" route is a registered nginx route
      // Replace module with app to access report-writer2 modules
      switch (meritRoute) {
        case 'module':
          pageUrl += 'app/';
          break;
        case 'merit':
          pageUrl += `merit-${orgCode}/`;
          break;
        case 'mphelp':
          pageUrl += 'view/static/mp/';
          break;
        default:
          pageUrl += `${meritRoute}/`;
          break;
      }
    }

    if (path) {
      pageUrl += path.replace(/\./g, '%2E');
    }

    if (this.props.location) {
      const xssRegExp = /<\/?.*>/;
      pageUrl = pageUrl.replace(xssRegExp, '') // MPSI-720 Handled XSS security violation
      
      // If any query parameters, stringify them and append them to the url
      if (this.props.location.query) {
        pageUrl += `?${queryString.stringify(this.props.location.query)}`;
      }
      // Handle query params via search
      if (this.props.location.search) {
        pageUrl += this.props.location.search;
      }
      // if any hash parameters, append them here
      if (this.props.location.hash) {
        pageUrl += this.props.location.hash.replace(/\./g, '%2E');
      }
    }

    // Handle session props
    if (pageUrl.indexOf('{') > -1) {
      pageUrl = dynamicColumnTemplate(pageUrl, this.state);
    }
    return pageUrl;
  };

  refreshJobTabData() {
    const iframe = document.querySelector('iframe.frame-iframe')?.contentWindow;
    const controller = iframe?.window.app.getController('pricingTabLauncher');
    controller?.refreshJobTabData();
  }

  refreshPrivateSurveyJobTabData() {
    const iframe = document.querySelector('iframe.frame-iframe')?.contentWindow;
    const controller = iframe?.window.app.getController('PrivateSurveyJobsMgr');
    controller?.refreshPrivateSurveyJobTabData();
  }

  refreshPrivateSurveyTabData() {
    const iframe = document.querySelector('iframe.frame-iframe')?.contentWindow;
    const controller = iframe?.window.app.getController('SurveySourcesGrid');
    controller?.refreshPrivateSurveyTabData();
  }

  refreshSurveyTabData() {
    const iframe = document.querySelector('iframe.frame-iframe')?.contentWindow;
    const controller = iframe?.window.app.getController('SurveyLibMgr');
    controller?.refreshSurveyTabData();
  }

  render() {
    /*
      Code below tests for structure modeling and resets the route if comp summary is refreshed
      This can be removed once structure modeling is rewritten in react
    */
    if (this.props.history.location) {
      const isStrucModeling =
        this.props.history.location.pathname.includes('/compensation-summary-report') &&
        this.props.history.location.pathname.includes('/structures/strucselect/structure-select/');
      const isPricingSideBySideDescription = this.props.history.location.pathname.includes('price/side-by-side');
      const isPricingJobDescription = this.props.history.location.pathname.includes('/price/job-description');
      const isJobsSideBySideDescription = this.props.history.location.pathname.includes('/jobs/side-by-side');
      const isJobsJobDescription = this.props.history.location.pathname.includes('/jobs/job-description');

      if (isPricingSideBySideDescription || isPricingJobDescription) {
        this.props.history.push('/iframe/merit/pricing2/price');
      }
      if (isJobsSideBySideDescription || isJobsJobDescription) {
        this.props.history.push('/iframe/merit/hris/job/jobs');
      }
      if (isStrucModeling) this.props.history.push('/iframe/merit/structures/strucselect/structure-select');
    }

    const iframeSrc = this.propsToIframeSrc();

    return (
      <React.Fragment>
        <div className={this.props.match.params.meritroute ? 'frame-wrapper legacy' : 'frame-wrapper'}>
          {iframeSrc && (
            <iframe
              key={`${this.state.groupId}-${this.state.currencyCode}`}
              className="frame-iframe"
              src={iframeSrc}
              onLoad={this.setLoaded}
              onClick={this.logClickEvent}
              id="acs-iframe"
            />
          )}
          <LoadingIndicator loading={this.state.iFrameLoading} />
        </div>

        <MatchReviewErrorModal
          displayCloseButton={true}
          tryAgain={this.participationMatchReviewLoadData}
          openReport={this.participationMatchReviewOpenReport}
          onClickClose={this.participationMatchReviewCloseSlideout}
          ref={m => {
            this.participationMatchReviewErrorModal = m;
          }}
        />

        <JDXSettingsModal show={this.state.showJDXSettingsModal} onClose={this.closeJDXSettingsModal} />
        <DefaultWeightModal
          show={this.state.showDefaultWeightModal}
          onClose={this.closeDefaultWeightModal}
          weighting={this.state.selectedDefaultWeighting}
          applyWeighting={this.props.applyWeighting}
          applyWeightingReducer={this.props.applyWeightingReducer}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ participationCenter, config, session, slideout, jobDetails, marketPricing, aging }) => ({
  config,
  session,
  participationCenterReview: participationCenter.matchReview,
  organization: session.organization,
  slideout,
  jobDetails,
  applyWeightingReducer: marketPricing.MarketPricingReducer.applyWeighting,
  defaultBenchmarkYear: aging.benchmarkYear
});

export default withRouter(
  connect(mapStateToProps, {
    showSlideout,
    hideSlideout,
    initializeAgreement,
    initParticipationMatchReview,
    resetParticipationMatchReview,
    loadParticipationMatchReviewItems,
    addJob,
    setSelectedBenchmarkYear,
    setDisplayIn,
    setViewName,
    setYearOverYearDisplayIn,
    setSelectedYearOverYearData,
    getJobsByID,
    setSelectedMigrationData,
    setSMAData,
    loadJobDetails,
    launchEditJobSlideout,
    getMarketplaceMatches,
    resetMarketplaceMatches,
    getJobPricingDetails,
    jobPricingSearch: jobPricingGridActions.search,
    applyWeighting,
    resetApplyWeighting,
    getApplyWeightingCounts
  })(updateCache(Iframe))
);
